<template>
  <div class="grid">
    <div data-cy="search-user-result" v-for="user in users"
         :key="user.id"
         class="item"
         :class="{ selected: ownerId===user.id }"
         @click="select(user.id)"
    >
      <v-image :image-id="user.idImage"
               :default="'DefaultUserPhoto.svg'"
               class="user-photo"
      />
      <div class="item-info">
        <span class="name">{{ user.firstName }} {{ user.lastName }}</span>
        <span>{{ user.department }}</span>
        <span>{{ businessAndLocation(user) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import VImage from '../shared/VImage'
import Utils from '../../utils'

export default {
  name: 'NameOwnerSearchResult',
  components: { VImage },
  props: {
    users: {
      type: Array,
      required: true
    },
    ownerId: {
      type: String,
      default: undefined
    }
  },
  methods: {
    select(userId) {
      this.$emit('select', userId)
    },
    businessAndLocation(user) {
      return [user.businessLine, user.location].filter(Utils.isNotBlank).join(' | ')
    }
  }
}
</script>

<style lang="scss" scoped>

.grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;

  &.selected {
    background-color: #e7e7e7;
    border: 1px solid $secondary-color;
  }

  &:hover {
    background-color: #d0d0d0;
  }

  .user-photo {
    height: 36px;
    border-radius: 100%;
    margin-right: 10px;
  }

  .item-info {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: $black-color;
    font-size: 15px;
    margin-left: 10px;

    .name {
      font-weight: 700;
      color: $primary-color;
      font-size: 16px;
    }
  }
}
</style>
